import { NavigateService } from '@shared/services/navigate.service';
import { AppInjector } from '@shared/services/app-injector.service';
import { Injector } from '@angular/core';

export class CalendarController {
  n: NavigateService;
  injector: Injector;

  constructor() {
    this.injector = AppInjector.getInjector();
    this.n = this.injector.get(NavigateService);
  }

  openEmployeeCalendar(employeeIds: number[]) {
    this.n.go('calendar', {}, {
      queryParams: {
        employees: '[' + employeeIds.toString() + ']'
      }
    });
  }
}
